import { Row, Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { OptionsQuestion } from "anketa-core/options_question";
import { getTranslation } from "../../../../";
import { OpenQuestion } from "anketa-core/open_question";
import { TextValidator } from "anketa-core/validation";

const ldapServerGenerator = (idx: number): OpenQuestion => {
  const idPrefix = `ldap_server_${idx}`;

  const ldapServerInput = new OpenQuestion(idPrefix, [
    new Translation("en", `${idx + 1}. LDAP-Server`),
    new Translation("de", `${idx + 1}. LDAP-Server`),
  ]);
  ldapServerInput.validator = new TextValidator();

  return ldapServerInput;
};

const generateLdapServer = (ldapServerSection: Row, idx = 0) => {
  const ldapServer = ldapServerGenerator(idx);

  ldapServerSection.addChild(ldapServer);

  function onConfigChange() {
    const fact = ldapServer.fact.raw;
    if (fact !== undefined && fact !== "") {
      generateLdapServer(ldapServerSection, idx + 1);
      ldapServer.removeChangeListener(onConfigChange);
    }
  }

  ldapServer.addChangeListener(onConfigChange);
};

const customAttributeGenerator = (idx: number): OpenQuestion => {
  const idPrefix = `ldap_custom_attr_${idx}`;

  const customAttributeInput = new OpenQuestion(idPrefix, [
    new Translation("en", `${idx + 1}. custom Attribute`),
    new Translation("de", `${idx + 1}. benutzerdefiniertes Attribut`),
  ]);
  customAttributeInput.validator = new TextValidator();

  return customAttributeInput;
};

const generateCustomAttribute = (customAttributeSection: Row, idx = 0) => {
  const customAttribute = customAttributeGenerator(idx);

  customAttributeSection.addChild(customAttribute);

  function onConfigChange() {
    const fact = customAttribute.fact.raw;
    if (fact !== undefined && fact !== "") {
      generateCustomAttribute(customAttributeSection, idx + 1);
      customAttribute.removeChangeListener(onConfigChange);
    }
  }

  customAttribute.addChangeListener(onConfigChange);
};

export const getLdapRow = (defaultValues: boolean) => {
  const ldapRow = new Section("ldap", [
    new Translation("en", "LDAP"),
    new Translation("en", "LDAP"),
  ]);

  const useLdap = new OptionsQuestion(
    "ldap_enable",
    [
      new Translation(
        "en",
        getTranslation("en", "anketa.opsanio.customer.dashboard.ldap.enable"),
      ),
      new Translation(
        "de",
        getTranslation("de", "anketa.opsanio.customer.dashboard.ldap.enable"),
      ),
    ],
    "default.options.yes_no",
  );

  ldapRow.addChild(useLdap);

  let ldapEnableSsl: OptionsQuestion = new OptionsQuestion(
    "ldaps_enable",
    [
      new Translation(
        "en",
        getTranslation(
          "en",
          "anketa.opsanio.customer.dashboard.ldap.enable.ssl.title",
        ),
      ),
      new Translation(
        "de",
        getTranslation(
          "de",
          "anketa.opsanio.customer.dashboard.ldap.enable.ssl.title",
        ),
      ),
    ],
    "default.options.yes_no",
  );
  ldapEnableSsl.help = [
    new Translation(
      "en",
      getTranslation("en", "anketa.opsanio.customer.dashboard.ldap.enable.ssl"),
    ),
    new Translation(
      "de",
      getTranslation("de", "anketa.opsanio.customer.dashboard.ldap.enable.ssl"),
    ),
  ];

  let ldapEnableSslClientAuth: OptionsQuestion = new OptionsQuestion(
    "ldap_client_auths",
    [
      new Translation(
        "en",
        getTranslation(
          "en",
          "anketa.opsanio.customer.dashboard.ldap.enable.client.auth.title",
        ),
      ),
      new Translation(
        "de",
        getTranslation(
          "de",
          "anketa.opsanio.customer.dashboard.ldap.enable.client.auth.title",
        ),
      ),
    ],
    "default.options.yes_no",
  );
  ldapEnableSslClientAuth.help = [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.enable.client.auth",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.enable.client.auth",
      ),
    ),
  ];

  let ldapEnableStartTls: OptionsQuestion = new OptionsQuestion(
    "ldap_starttls",
    [
      new Translation(
        "en",
        getTranslation(
          "en",
          "anketa.opsanio.customer.dashboard.ldap.enable.starttls.title",
        ),
      ),
      new Translation(
        "de",
        getTranslation(
          "de",
          "anketa.opsanio.customer.dashboard.ldap.enable.starttls.title",
        ),
      ),
    ],
    "default.options.yes_no",
  );
  ldapEnableStartTls.help = [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.enable.starttls",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.enable.starttls",
      ),
    ),
  ];

  let ldapVerifyHostnames: OptionsQuestion = new OptionsQuestion(
    "ldap_verify_hostnames",
    [
      new Translation(
        "en",
        getTranslation(
          "en",
          "anketa.opsanio.customer.dashboard.ldap.enable.verify.hostnames.title",
        ),
      ),
      new Translation(
        "de",
        getTranslation(
          "de",
          "anketa.opsanio.customer.dashboard.ldap.enable.verify.hostnames.title",
        ),
      ),
    ],
    "default.options.yes_no",
  );
  ldapVerifyHostnames.help = [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.enable.verify.hostnames",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.enable.verify.hostnames",
      ),
    ),
  ];

  let serverRow: Row = new Row("ldap_server", [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.servers.title",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.servers.title",
      ),
    ),
  ]);
  serverRow.help = [
    new Translation(
      "en",
      getTranslation("en", "anketa.opsanio.customer.dashboard.ldap.servers"),
    ),
    new Translation(
      "de",
      getTranslation("de", "anketa.opsanio.customer.dashboard.ldap.servers"),
    ),
  ];

  generateLdapServer(serverRow);

  let domain = new OpenQuestion("ldap_domain", [
    new Translation("en", `LDAP Domain`),
    new Translation("de", `LDAP Domain`),
  ]);
  domain.validator = new TextValidator();

  let bindUser = new OpenQuestion("ldap_dn_user", [
    new Translation("en", `LDAP Bind user`),
    new Translation("de", `LDAP Bind Nutzer`),
  ]);
  bindUser.validator = new TextValidator();

  let userbase = new OpenQuestion("ldap_usrbase", [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.userbase.title",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.userbase.title",
      ),
    ),
  ]);
  userbase.help = [
    new Translation(
      "en",
      getTranslation("en", "anketa.opsanio.customer.dashboard.ldap.userbase"),
    ),
    new Translation(
      "de",
      getTranslation("de", "anketa.opsanio.customer.dashboard.ldap.userbase"),
    ),
  ];
  userbase.validator = new TextValidator();

  let usersearch = new OpenQuestion("ldap_usrsearch", [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.usersearch.title",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.usersearch.title",
      ),
    ),
  ]);
  usersearch.help = [
    new Translation(
      "en",
      getTranslation("en", "anketa.opsanio.customer.dashboard.ldap.usersearch"),
    ),
    new Translation(
      "de",
      getTranslation("de", "anketa.opsanio.customer.dashboard.ldap.usersearch"),
    ),
  ];
  usersearch.validator = new TextValidator();

  let usernameAttribute = new OpenQuestion("ldap_usr_attr", [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.username.attribute.title",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.username.attribute.title",
      ),
    ),
  ]);
  usernameAttribute.help = [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.username.attribute",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.username.attribute",
      ),
    ),
  ];
  usernameAttribute.validator = new TextValidator();

  let customAttributeRow: Row = new Row("ldap_custom_attr", [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.custom.attr.allowlist.title",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.custom.attr.allowlist.title",
      ),
    ),
  ]);
  customAttributeRow.help = [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.custom.attr.allowlist",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.custom.attr.allowlist",
      ),
    ),
  ];
  generateCustomAttribute(customAttributeRow);

  let rolebase = new OpenQuestion("ldap_rolebase", [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.rolebase.title",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.rolebase.title",
      ),
    ),
  ]);
  rolebase.help = [
    new Translation(
      "en",
      getTranslation("en", "anketa.opsanio.customer.dashboard.ldap.rolebase"),
    ),
    new Translation(
      "de",
      getTranslation("de", "anketa.opsanio.customer.dashboard.ldap.rolebase"),
    ),
  ];
  rolebase.validator = new TextValidator();

  let rolesearch = new OpenQuestion("ldap_rolesearch", [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.rolesearch.title",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.rolesearch.title",
      ),
    ),
  ]);
  rolesearch.help = [
    new Translation(
      "en",
      getTranslation("en", "anketa.opsanio.customer.dashboard.ldap.rolesearch"),
    ),
    new Translation(
      "de",
      getTranslation("de", "anketa.opsanio.customer.dashboard.ldap.rolesearch"),
    ),
  ];
  rolesearch.validator = new TextValidator();

  let userroleattribute = new OpenQuestion("ldap_usrroleattr", [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.userroleattribute.title",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.userroleattribute.title",
      ),
    ),
  ]);
  userroleattribute.help = [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.userroleattribute",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.userroleattribute",
      ),
    ),
  ];
  userroleattribute.validator = new TextValidator();

  let userrolename = new OpenQuestion("ldap_usrrolename", [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.userrolename.title",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.userrolename.title",
      ),
    ),
  ]);
  userrolename.help = [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.userrolename",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.userrolename",
      ),
    ),
  ];
  userrolename.validator = new TextValidator();

  let rolename = new OpenQuestion("ldap_rolename", [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.rolename.title",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.rolename.title",
      ),
    ),
  ]);
  rolename.help = [
    new Translation(
      "en",
      getTranslation("en", "anketa.opsanio.customer.dashboard.ldap.rolename"),
    ),
    new Translation(
      "de",
      getTranslation("de", "anketa.opsanio.customer.dashboard.ldap.rolename"),
    ),
  ];
  rolename.validator = new TextValidator();

  let resolveNestedRoles: OptionsQuestion = new OptionsQuestion(
    "ldap_resolve_nested_roles",
    [
      new Translation(
        "en",
        getTranslation(
          "en",
          "anketa.opsanio.customer.dashboard.ldap.enable.verify.resolve.nested.roles.title",
        ),
      ),
      new Translation(
        "de",
        getTranslation(
          "de",
          "anketa.opsanio.customer.dashboard.ldap.enable.verify.resolve.nested.roles.title",
        ),
      ),
    ],
    "default.options.yes_no",
  );
  resolveNestedRoles.help = [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.ldap.enable.verify.resolve.nested.roles",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.ldap.enable.verify.resolve.nested.roles",
      ),
    ),
  ];
  useLdap.addChangeListener(() => {
    const enableLdapAuthRaw = useLdap.fact.raw;

    const enableLdapAuth =
      enableLdapAuthRaw !== undefined ? enableLdapAuthRaw === "0" : false;

    const children = [
      ldapEnableSsl,
      ldapEnableSslClientAuth,
      ldapVerifyHostnames,
      serverRow,
      domain,
      bindUser,
      userbase,
      usersearch,
      usernameAttribute,
      customAttributeRow,
      rolebase,
      rolesearch,
      userroleattribute,
      userrolename,
      rolename,
      resolveNestedRoles,
    ];

    if (enableLdapAuth) {
      children.forEach((child) => {
        if (!ldapRow.containsChild(child)) {
          ldapRow.addChild(child);
        }
      });
    } else {
      children.forEach((child) => {
        if (ldapRow.containsChild(child)) {
          ldapRow.removeChild(child);
        }
      });
    }
  });

  ldapEnableSsl.addChangeListener(() => {
    const enableLdapAuth = useLdap.fact.raw === "0";
    const enableLdaps = ldapEnableSsl.fact.raw === "0";

    if (!enableLdapAuth) {
      return;
    }

    if (enableLdaps) {
      ldapEnableStartTls.setFactValue("1");

      if (ldapRow.containsChild(ldapEnableStartTls)) {
        ldapRow.removeChild(ldapEnableStartTls);
      }
    } else {
      if (!ldapRow.containsChild(ldapEnableStartTls)) {
        ldapRow.addChild(ldapEnableStartTls);
      }
    }
  });

  if (defaultValues) {
    useLdap.setFactValue(1);
  }
  return ldapRow;
};
